import axios, { AxiosRequestConfig } from 'axios';
// config

// ----------------------------------------------------------------------

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: any) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  cart: import.meta.env.VITE_CART_API_URL,
  profiles: import.meta.env.VITE_CART_API_URL + '/profiles',
  availability: import.meta.env.VITE_SEARCH_API_URL
};
